var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesStamps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 132,
    viewBox: "0 0 147 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.418 48.7L131.618 126.6C131.568 127.24 131.39 127.864 131.095 128.435C130.799 129.005 130.392 129.51 129.898 129.921C129.404 130.331 128.832 130.638 128.217 130.823C127.602 131.009 126.956 131.069 126.318 131L57.0176 125C55.7265 124.873 54.5353 124.249 53.6956 123.26C52.8559 122.271 52.4335 120.995 52.5176 119.7L60.4176 29.5C60.5686 28.227 61.2027 27.0605 62.189 26.2417C63.1754 25.4229 64.4385 25.0141 65.7176 25.1L123.518 30.2L138.418 48.7Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7175 16L70.0175 17.7L68.4175 -1L88.7175 16Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7175 16L70.0175 17.7L68.4175 -1L88.7175 16Z",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6176 40.9L26.6176 41.2L26.0176 43.5H25.0176L27.1176 35.5H28.1176L31.6176 43H30.6176L29.6176 40.9ZM26.8176 40.4L29.3176 40.1L27.7176 36.8L26.8176 40.4Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1175 79.6L28.4175 71.9L31.4175 71.7C31.6878 71.6424 31.967 71.6415 32.2377 71.6973C32.5083 71.7531 32.7645 71.8644 32.99 72.0241C33.2155 72.1838 33.4054 72.3885 33.5479 72.6253C33.6903 72.8622 33.7821 73.1259 33.8175 73.4C33.8575 73.7927 33.7597 74.187 33.5407 74.5155C33.3218 74.8439 32.9954 75.0859 32.6175 75.2C33.0976 75.2216 33.5539 75.4155 33.9028 75.746C34.2517 76.0766 34.4699 76.5217 34.5175 77C34.6175 78.3 33.7175 79.2 32.1175 79.4L29.1175 79.6ZM29.7175 75.2L31.2175 75C32.3175 74.9 32.9175 74.4 32.8175 73.6C32.7175 72.8 32.2175 72.5 31.3175 72.5L29.4175 72.7L29.7175 75.2ZM31.9175 78.5C33.0175 78.4 33.6175 77.9 33.5175 77C33.4175 76.1 32.8175 75.7 31.5175 75.8L29.7175 76L30.0175 78.7L31.9175 78.5Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3175 48.5C33.2328 48.5 37.2175 44.5153 37.2175 39.5999C37.2175 34.6846 33.2328 30.7 28.3175 30.7C23.4021 30.7 19.4175 34.6846 19.4175 39.5999C19.4175 44.5153 23.4021 48.5 28.3175 48.5Z",
    stroke: "#DB6C2F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4176 84.5C36.3329 84.5 40.3176 80.5153 40.3176 75.6C40.3176 70.6846 36.3329 66.7 31.4176 66.7C26.5022 66.7 22.5176 70.6846 22.5176 75.6C22.5176 80.5153 26.5022 84.5 31.4176 84.5Z",
    stroke: "#DB6C2F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1177 16.3L86.6177 21.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1176 58C74.4025 58.0123 74.682 58.0825 74.9389 58.2063C75.1958 58.3301 75.4248 58.5049 75.612 58.7201C75.7991 58.9353 75.9405 59.1864 76.0274 59.458C76.1143 59.7297 76.145 60.0162 76.1176 60.3C76.0925 60.5894 76.0103 60.8709 75.8759 61.1284C75.7414 61.3858 75.5573 61.6141 75.3342 61.8C75.1111 61.9859 74.8534 62.1259 74.5759 62.2117C74.2984 62.2975 74.0067 62.3275 73.7176 62.3L72.0176 62.1L71.8176 64.5H71.0176L71.6176 57.8L74.1176 58ZM72.1176 61.4H73.6176C73.8114 61.4461 74.0133 61.447 74.2075 61.4026C74.4017 61.3583 74.5832 61.2698 74.7378 61.1442C74.8925 61.0186 75.0161 60.8591 75.0993 60.678C75.1825 60.497 75.223 60.2992 75.2176 60.1C75.3176 59.3 74.8176 58.7 73.8176 58.6H72.3176L72.1176 61.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4176 65.4C78.5176 65.2 77.4175 63.8 77.6175 61.6C77.8175 59.4 79.1175 58.3 81.0175 58.5C81.661 58.5396 82.271 58.8 82.7447 59.2372C83.2184 59.6745 83.5267 60.2618 83.6175 60.9H82.7175C82.6321 60.4739 82.4101 60.0874 82.0854 59.7987C81.7606 59.51 81.3507 59.3349 80.9176 59.3C79.5176 59.2 78.6175 60.1 78.5175 61.8C78.4175 63.5 79.1176 64.6 80.4176 64.7C80.6749 64.7423 80.9382 64.7311 81.1911 64.6672C81.444 64.6033 81.681 64.488 81.8874 64.3286C82.0937 64.1691 82.2651 63.9688 82.3907 63.7402C82.5163 63.5117 82.5935 63.2597 82.6175 63L80.7175 62.8V62.1L83.4176 62.3V63C83.3942 63.3608 83.2958 63.7127 83.1287 64.0333C82.9616 64.3539 82.7295 64.6362 82.4472 64.862C82.1649 65.0879 81.8386 65.2524 81.4891 65.345C81.1396 65.4376 80.7747 65.4564 80.4176 65.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0176 99.4C72.0176 100.2 72.7176 100.8 73.8176 100.9C74.202 100.991 74.6066 100.926 74.9436 100.72C75.2806 100.514 75.5228 100.183 75.6176 99.8C75.7176 99.1 75.3176 98.7 74.3176 98.4L73.3176 98C72.0176 97.6 71.5176 96.9 71.5176 95.9C71.5176 94.9 72.8176 93.9 74.4176 94C75.0462 94.0246 75.6424 94.2854 76.0873 94.7303C76.5321 95.1751 76.7929 95.7713 76.8176 96.4H75.8176C75.8197 96.198 75.778 95.998 75.6955 95.8136C75.613 95.6293 75.4916 95.465 75.3396 95.332C75.1876 95.199 75.0086 95.1005 74.8149 95.0431C74.6213 94.9858 74.4175 94.9711 74.2176 95C73.3176 94.9 72.6176 95.3 72.5176 96C72.4176 96.7 72.8176 97 73.8176 97.3L74.6176 97.6C76.1176 98.1 76.7176 98.8 76.6176 99.8C76.5176 100.8 75.3176 101.9 73.6176 101.8C73.2892 101.813 72.9614 101.762 72.653 101.648C72.3445 101.535 72.0614 101.362 71.82 101.139C71.5785 100.916 71.3833 100.648 71.2456 100.349C71.1079 100.051 71.0305 99.7284 71.0176 99.4H72.0176Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4176 70.5C82.3329 70.5 86.3176 66.5153 86.3176 61.5999C86.3176 56.6846 82.3329 52.7 77.4176 52.7C72.5022 52.7 68.5176 56.6846 68.5176 61.5999C68.5176 66.5153 72.5022 70.5 77.4176 70.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2176 106.6C79.133 106.6 83.1176 102.615 83.1176 97.7C83.1176 92.7847 79.133 88.8 74.2176 88.8C69.3023 88.8 65.3176 92.7847 65.3176 97.7C65.3176 102.615 69.3023 106.6 74.2176 106.6Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1176 103.1L19.2176 105.5C18.5737 105.555 17.9253 105.482 17.3098 105.285C16.6943 105.088 16.1238 104.771 15.6312 104.353C15.1386 103.935 14.7336 103.423 14.4395 102.848C14.1454 102.272 13.968 101.644 13.9176 101L6.0176 10.9C5.96288 10.2561 6.03606 9.60773 6.23294 8.99222C6.42982 8.37672 6.7465 7.80624 7.16476 7.31363C7.58302 6.82101 8.09458 6.416 8.67001 6.1219C9.24543 5.8278 9.87335 5.65043 10.5176 5.6L68.3176 0.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5176 30.3L54.0176 29.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3176 39L52.5176 38.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0176 47.7L50.5176 47.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7175 66.4L51.0175 66",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.018 49L122.318 47.3L123.918 28.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0176 55.2L124.218 57.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2175 63.9L123.518 66.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5176 72.5L116.618 74.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8176 91.3L121.118 93.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1177 100L120.318 102.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3176 108.6L113.418 110.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H147V132H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesStamps);
export default __webpack_public_path__ + "static/media/pages_stamps.138b3ebbee3eed7307b9bda202fd503f.svg";
export { ForwardRef as ReactComponent };